import { CommonModule, Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ConnectiveservicesService } from '../../../Services/Apis/Connectiveservices/connectiveservices.service';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { ApiservicesService } from '../../../Services/Apis/apiservices.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { map } from 'rxjs';
import { ToastService } from '../../../Services/toast/toast.service';
import { TranslateDirective } from '../../../components/Utilites/Directives/translate.directive';
import { TranslatePipe } from '../../../components/Utilites/Pipe/translate.pipe';

@Component({
  selector: 'app-editemployeerole',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatCardModule,
    MatButtonModule,
    MatSlideToggleModule,
    TranslateDirective,
    TranslatePipe,
  ],
  templateUrl: './editemployeerole.component.html',
  styleUrl: './editemployeerole.component.scss',
})
export class EditemployeeroleComponent implements OnInit {
  userrole_type_list: any = [];
  toggleStatus: boolean = false;
  routedata$: any;
  constructor(
    private connectiveservice: ConnectiveservicesService,
    private location: Location,
    private apiservice: ApiservicesService,
    private router: Router,
    private toast: ToastService,
    public activatedRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.routedata$ = history.state?.empId;
    this.getroleslist();
  }

  getroleslist() {
    this.apiservice.getroletypelist(this.routedata$).subscribe((res: any) => {
      this.userrole_type_list = res.rows;
    });
  }

  onToggleChange(event: any, role_id: number) {
    let submit_data: any = {
      id: this.routedata$,
      roles: [
        {
          role_id: role_id,
          status: event.checked === true ? 'ACTIVE' : 'INACTIVE',
        },
      ],
    };
    this.apiservice.patchroletypelist(submit_data).subscribe((res: any) => {
      this.userrole_type_list = res;
      if (res.code === 200) {
        this.getroleslist();
      } else {
        this.toast.showToast('danger', res.error.errorMessage);
      }
    });
  }
  NavigateToBack() {
    // this.resetemployeeform();
    this.location.back();
  }
}
